import { Session } from 'src/models/session/_types';
import { User } from 'src/models/user/_types';
import { isAdmin, isSupportRole } from 'src/models/user/utils';

export function isLoggedIn({
  user,
  session,
  adminOnly = false,
  userOnly = false,
}: {
  user: User | undefined | null;
  session: Session | undefined;
  adminOnly?: boolean;
  userOnly?: boolean;
}): boolean {
  if (!user?.id) {
    return false;
  }

  // Exercise staff on www/staging have a user but no tenant platform session.
  if (adminOnly) {
    return isAdmin(user) || isSupportRole(user);
  }

  // Post-business-checkout waiver on www.exercise.com: user is signed in but
  // has no tenant platform session until the waiver creates their subdomain.
  if (userOnly) {
    return true;
  }

  if (!session?.id) {
    return false;
  }

  return true;
}
